
import { Component, Vue } from 'vue-property-decorator'
import { cityEndpoints } from '@/modules/preference/city'
import { ICity } from '@/modules/preference/city/types/cityTypes'
import { Field } from '@/services/utils/baseForm'

import { popUpRoute } from '@/services/utils/popupRoute'
import { parsePathQueryString } from '@/shared/helpers/parsePathQueryString'
import BaseForm from '@/stories/base-form/BaseForm.vue'
import { Route } from 'vue-router'

import eventBus from '@/eventBus'
import { freezeObject } from '@/shared/helpers/freezeObject'

@Component({
  name: 'TheUpsertCity',
  components: {
    DialogBaseSkeleton: () =>
      import(
        /* webpackChunkName: DialogBaseSkeleton */ '@/stories/dialog-base-skeleton/DialogBaseSkeleton.vue'
      ),
    BaseForm
  }
})
export default class TheUpsertCity extends Vue {
  loading = false
  data = {} as ICity
  id = this.$route.params.id || ''
  originalData = {}

  title = (_params: Route['params'], query: Route['query']) =>
    query.id
      ? `${this.$t('dialog.city.edit')}`
      : `${this.$t('dialog.city.addNew')}`

  /**
   * function will be passed to child components
   * @params City which modules type the fetched Cities will be passed to it in the child component. (base form)
   */
  fields(): Field<ICity>[] {
    return [Field.text<ICity>('name', 'name').setCol('col-12').required()]
  }

  /**
   * submit the data to the desired endpoint.
   */
  async handleSubmit(
    values: ICity,
    p: Record<string, number>,
    q: Record<string, number>
  ) {
    if (q.id) {
      await cityEndpoints
        .patch(q.id, this.originalData, values, false)
        .then(() => popUpRoute.removeModalPath(['id']))
    } else
      await cityEndpoints.post(values, false).then(() => {
        popUpRoute.removeModalPath(['id'])
      })
    eventBus.refreshData()
  }

  bindSubmitTitle(params: Route['params'], query: Route['query']): string {
    return query.id ? 'update' : 'add'
  }

  /**
   * closePopUp function pass to the baseModal component
   */
  closePopUp() {
    popUpRoute.removeModalPath(['id'])
  }

  created() {
    this.fetchRemoteData()
  }

  /**
   * call given fetch data function
   */
  async fetchRemoteData() {
    const id = parsePathQueryString(location.search).id
    this.loading = true
    try {
      if (id) {
        this.data = await cityEndpoints.get(id)
        this.originalData = freezeObject(this.data)
      }
    } catch (error) {
      throw new Error(`Failed to fetch form data. Due to ${error}`)
    } finally {
      this.loading = false
    }
  }
}
